import { Injectable } from '@angular/core';
import { catchError,map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { Observable, throwError } from 'rxjs';
import { Nacionalidades, RequestResponseGetAllNacionalidades, RequestResponseActualizar } from 'src/app/shared/models/nacionalidades.interface';

@Injectable({
  providedIn: 'root'
})
export class NacionalidadesService {

  constructor(private http:HttpClient,private router: Router,private alert:AlertHelper) { }
  //GetAll_nacionalidades
  traerNacionalidades(): Observable<RequestResponseGetAllNacionalidades> {
    return this.http
    .get<RequestResponseGetAllNacionalidades >(`${environment.API}/rrhh/nacionalidad/`)
    .pipe(
      map((res:RequestResponseGetAllNacionalidades) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Create_nacionalidad
  crearNacionalidad(nacionalidad:Nacionalidades): Observable<RequestResponse> {     
    return this.http
    .post<RequestResponse >(`${environment.API}/rrhh/nacionalidad/crear/`, nacionalidad)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Actualizar_nacionalidad
  actualizarNacionalidad(nacionalidad:any): Observable<RequestResponseActualizar>  {
    return this.http
    .put<RequestResponseActualizar >(`${environment.API}/rrhh/nacionalidad/actualizar/${nacionalidad.id}`,nacionalidad)
    .pipe(
      map((res:RequestResponseActualizar) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Obtener_nacionalidad
  obtenerNacionalidad(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/nacionalidad/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Eliminar_nacionalidad
  eliminarNacionalidad(id:number): Observable<RequestResponse> {
    return this.http
    .delete<RequestResponse >(`${environment.API}/rrhh/nacionalidad/eliminar/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }


  private handlerError(err: any):Observable<never>{

    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }
}
